<template>
    <div>
    <div id="footer" class="container-fluid">
        <!-- <div class="logo1" style="margin-top:40px">
        <img src="@/assets/img/logo1.png" alt="logo图">
    </div> -->
        <div class="ms-footer" style=" ">

            <div class="body">
                <div class="logo1" style="">
                    <el-image style="width: 172px; height:54px" :src="require('@/assets/img/logo1.png')" fit="cover" />
                </div>
                <div class="content1">
                    <div class="contactDetails1 lxfs wow slideInUp">
                        <p class="mgb2px lxfsLv1" style="">联系方式</p>
                        <p class="mgb2px lxfsLv2" style="margin-bottom:25px;opacity: 0.5;">
                            <span class="mgr160px lxfsLv2Phone" style="">
                                <el-image class="mgr5px"
                                    style="width: 21px; height:21px;vertical-align: middle;margin-right:22px;"
                                    :src="require('@/assets/img/phone.png')" fit="cover">
                                </el-image>
                                电话：0755-8287-4699
                            </span>
                            <span class="lxfsLv2Phone">
                                <el-image class="mgr3px"
                                    style="width: 23px; height:16px;vertical-align: middle;margin-right:22px;"
                                    :src="require('@/assets/img/email.png')" fit="cover"></el-image>
                                电子邮件：postmaster@ghcapital.cn
                            </span>
                        </p>
                        <p style="opacity: 0.5;display: flex;justify-content: start;"><span>
                                <el-image class="mgr5px"
                                    style="width:19px; height:21px;vertical-align: middle;margin-right:22px;"
                                    :src="require('@/assets/img/map.png')" fit="cover"></el-image>
                                地址：深圳市南山区深圳湾科技生态园12栋A裙楼4层407
                            </span></p>
                    </div>
                    <div class="contactDetails1 mgl5px yqlink wow slideInUp" style="">
                        <p class="mgb0px"
                            style="font-size:20px;color:#ffffff;font-weight:400;margin-bottom:30px;display: flex;justify-content: start;">
                            友情链接</p>

                        <p class="mgb4px" style="margin-bottom:25px;opacity: 0.5;"><span>国华三新：</span>
                            <el-link class="fs12px" href="http://www.ghsxcapital.com/" type="info"
                                style="font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;color: #FFFFFF;">
                                http://www.ghsxcapital.com/</el-link>
                        </p>

                        <p style="opacity: 0.5;"><span>国华家里：</span>
                            <el-link class="fs12px" href="http://www.ghjlcapital.com/" type="info"
                                style="font-size: 16px;font-family: Source Han Sans CN;font-weight: 400;color: #FFFFFF;opacity: ">
                                http://www.ghjlcapital.com/</el-link>
                        </p>
                    </div>
                    <div class="contactDetails1 positionA gzh wow slideInRight" style="text-align:center">
                        <p>
                            <el-image class="mgt0px QRcodeImg" style="width: 92px; height:92px;margin-top: 10px;"
                                :src="require('@/assets/img/QRcode.png')" fit="cover"></el-image>
                        </p>
                        <p class="QRcodeMes" style="">
                            微信公众号</p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
    <div>
        <div class="col-md-12 col-sm-12 FilingNumber">
				<p>Copyright @ GH Investment Management Corp., Ltd.</p>
				<p><a href="https://beian.miit.gov.cn"><font color="black">粤ICP备16023892号</font></a></p>
        </div>
    </div>
    </div>
</template>
<script>
import { WOW } from 'wowjs';
export default {
    name: "Footer",
    data() {
        return {};
    },
    mounted() {
        var wow = new WOW();
        wow.init();
    },
};
</script>
<style scoped>
#footer {
    width: 100%;
    height: 100%;
    color: #fff;
    background: #474747;
    overflow: hidden;
    text-align: center;
    background-image: url("../assets/img/footer1.jpg");
}
.FilingNumber{
    text-align: center;
    margin:30px 0 10px 0;
}
.FilingNumber p{
    line-height: 28px;
    padding-top: 10px;
}
.ms-footer {
    /* background-color: #F2F2F2; */


    align-items: center;
    flex-direction: row;
    display: flex;
    padding-right: 0px;
    box-sizing: border-box;
    justify-content: center;
    padding-bottom: 0px;
    flex-wrap: nowrap;
    margin-bottom: 0px;
    padding-top: 0px;
    padding-left: 0px;
    margin-top: 0px;
    width: 100%;
    height: 294px
}

.ms-footer .body {
    flex-wrap: nowrap;
    flex-direction: column;
    display: flex;
    padding-right: 0px;
    width: 1200px;
    margin-bottom: 20px;
    box-sizing: border-box;
    padding-left: 0px;
    justify-content: flex-start;
    margin-top: 20px;
    height: 100%;
}

.ms-footer .body .top {
    align-items: center;
    flex-direction: row;
    display: flex;
    padding-right: 0px;
    box-sizing: border-box;
    justify-content: space-between;
    padding-bottom: 0px;
    flex-wrap: nowrap;
    width: 100%;
    margin-bottom: 40px;
    padding-top: 0px;
    padding-left: 0px;
    margin-top: 0px;
    height: 60%;
}

.ms-footer .body .logo {
    margin-top: 55px;
}

.ms-footer .body .top .top-left {
    flex-wrap: nowrap;
    flex-direction: row;
    display: flex;
    width: 60%;
    box-sizing: border-box;
    padding-top: 0px;
    padding-left: 0px;
    height: 120px;
}

.ms-footer .body .top .top-left .foot-nav {
    flex-wrap: nowrap;
    flex-direction: column;
    display: flex;
    width: 148px;
    box-sizing: border-box;
    padding-top: 0px;
    height: 100%;
}

.ms-footer .body .top .top-left .foot-nav .nav-item {
    flex-direction: row;
    word-wrap: break-word;
    display: inline-block;
    font-size: 18PX;
    padding-top: 6px;
    height: 32px;
}

.ms-footer .body .top .top-left .foot-nav div {
    flex-wrap: nowrap;
    flex-direction: row;
    display: flex;
    width: 100%;
    box-sizing: border-box;
    padding-top: 0px;
    height: 30px;
}

.ms-footer .body .top .top-left .foot-nav div .item {
    color: #767676;
    flex-direction: row;
    word-wrap: break-word;
    display: inline-block;
    font-size: 16PX;
    padding-top: 6px;
    height: 32px;
}

.ms-footer .body .top .top-right {
    flex-wrap: nowrap;
    flex-direction: row;
    display: flex;
    width: 40%;
    box-sizing: border-box;
    padding-top: 0px;
    padding-left: 0px;
    height: 100%;
}

.ms-footer .body .top .top-right .qr {
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;
    display: flex;
    width: 50%;
    box-sizing: border-box;
    justify-content: center;
    height: 100%;
}

.ms-footer .body .top .top-right .qr .pic {
    width: 120px;
    height: 120px;
}

.ms-footer .body .top .top-right .qr .text {
    flex-direction: row;
    word-wrap: break-word;
    display: inline-block;
    font-size: 14px;
}

.ms-footer .body .copyright {
    text-align: left;
    flex-direction: row;
    word-wrap: break-word;
    display: inline-block;
    font-size: 14px;
    padding-top: 6px;
    height: 32px;
}

.ms-footer .body .power {
    color: #5B5B5B;
    text-align: left;
    flex-direction: row;
    word-wrap: break-word;
    display: inline-block;
    font-size: 14px;
    margin-bottom: 0px;
    padding-top: 0px;
    margin-top: 0px;
}

.ms-footer .body .content1 {
    margin-top: 30px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    display: flex;
    justify-content: space-between;
}

.ms-footer .body .lxfs .lxfsLv1 {
    font-size: 20px;
    color: #ffffff;
    font-weight: 400;
    margin-bottom: 25px;
    display: flex;
    justify-content: start;
}

.ms-footer .body .lxfs .lxfsLv2 .lxfsLv2Phone {
    margin-right: 47px;
    
}

.ms-footer .body .positionA {}

.ms-footer .body .positionA .QRcodeImg {
    width: 92px;
    height: 92px;
    margin-top: 10px;
}

.ms-footer .body .positionA .QRcodeMes {
    font-size: 14px;
    color: #FFFFFF;
    line-height: 36px;
}

.ms-footer .body .logo1 {
    margin-top: 40px;
    display: flex;
    justify-content: start;
}

@media (max-width: 768px) {
    .ms-footer {
        /* background-color: #F2F2F2; */
        align-items: center;
        flex-direction: row;
        display: flex;
        padding-right: 0px;
        box-sizing: border-box;
        justify-content: center;
        padding-bottom: 0px;
        flex-wrap: nowrap;
        width: 100%;
        padding-top: 0px;
        padding-left: 0px;
        margin-top: 0px;
        height: unset;
    }

    .ms-footer .body {
        padding-bottom: 10px;
        flex-wrap: nowrap;
        flex-direction: column;
        display: flex;
        padding-right: 10px;
        width: 100%;
        box-sizing: border-box;
        padding-top: 10px;
        padding-left: 10px;
        margin-top: 0px;
        height: 100%;
    }

    .ms-footer .body .logo1 {
        margin-top: 3px !important;
        margin-top: 40px;
        display: flex;
        justify-content: start;
        margin-bottom: 5px;
    }

    .ms-footer .body .content1 {
        margin-top: 0px !important;
        position: relative;
        font-size: 14px;
        color: rgb(255, 255, 255);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .ms-footer .body .fs12px {
        font-size: 12px !important;
    }

    .ms-footer .body .mgr160px {
        margin-right: 160px !important;
    }

    .ms-footer .body .mgb2px {
        margin-bottom: 2px !important;
    }

    .ms-footer .body .mgb0px {
        margin-bottom: 0px !important;
    }

    .ms-footer .body .mgb4px {
        margin-bottom: 0px !important;
    }

    .ms-footer .body .mgr5px {
        margin-right: 5px !important;
    }

    .ms-footer .body .mgl5px {
        margin-left: 5px !important;
    }

    .ms-footer .body .mgr3px {
        margin-right: 3px !important;
    }

    .ms-footer .body .mgt0px {
        margin-top: 0px !important;
    }

    .ms-footer .body .lxfs {}

    .ms-footer .body .lxfs .lxfsLv1 {}

    .ms-footer .body .lxfs .lxfsLv2 {
        display: flex;
        flex-direction: column;
    }

    .ms-footer .body .lxfs .lxfsLv2 .lxfsLv2Phone {
        display: flex;
        margin-right: 0 !important;
        margin-bottom: 5px;
    }

    .ms-footer .body .yqlink {
        text-align: start;
    }

    .ms-footer .body .positionA {
        display: flex;
        flex-direction: column;
    }

    .ms-footer .body .positionA .QRcodeMes {
        font-size: 12px;
        color: #FFFFFF;
        line-height: 12px;
    }

    .ms-footer .body .top {
        padding-bottom: 0px;
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: column;
        display: flex;
        padding-right: 0px;
        width: 100%;
        box-sizing: border-box;
        padding-top: 0px;
        padding-left: 0px;
        justify-content: space-between;
        margin-top: 0px;
    }

    .ms-footer .body .top .top-left {
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
        display: flex;
        width: 100%;
        box-sizing: border-box;
        margin-bottom: 20px;
        padding-top: 0px;
        padding-left: 0px;
        justify-content: flex-start;
        height: unset;

    }

    .ms-footer .body .top .top-left .foot-nav {
        flex-wrap: nowrap;
        flex-direction: column;
        display: flex;
        width: 50%;
        box-sizing: border-box;
        margin-bottom: 0px;
        padding-left: 0px;
    }

    .ms-footer .body .top .top-left .foot-nav .nav-item {
        flex-direction: row;
        word-wrap: break-word;
        display: inline-block;
        font-size: 18PX;
        padding-top: 6px;
        height: 32px;
    }

    .ms-footer .body .top .top-left .foot-nav div .item {
        color: #767676;
        flex-direction: row;
        word-wrap: break-word;
        display: inline-block;
        font-size: 16PX;
        padding-top: 6px;
        height: 32px;
    }

    .ms-footer .body .top .top-right {
        flex-wrap: nowrap;
        flex-direction: row;
        display: flex;
        width: 100%;
        box-sizing: border-box;
        padding-top: 0px;
        padding-left: 0px;
    }

    .ms-footer .body .top .top-right .qr {
        align-items: center;
        flex-wrap: nowrap;
        flex-direction: column;
        display: flex;
        width: 50%;
        box-sizing: border-box;
        padding-left: 0px;
        justify-content: center;
        height: 100%;
    }

    .ms-footer .body .top .top-right .qr .pic {
        width: 120px;
        height: 120px;
    }

    .ms-footer .body .top .top-right .qr .text {
        flex-direction: row;
        word-wrap: break-word;
        display: inline-block;
        font-size: 14px;
    }

    .ms-footer .body .copyright {
        text-align: center;
        flex-direction: row;
        word-wrap: break-word;
        display: inline-block;
        font-size: 14px;
        padding-top: 6px;
        height: unset;
    }

    .ms-footer .body .power {
        color: #5B5B5B;
        text-align: center;
        flex-direction: row;
        word-wrap: break-word;
        display: inline-block;
        font-size: 14px;
        padding-top: 0px;
    }
}</style>




// WEBPACK FOOTER //
// src/components/Footer.vue